import { Attribute, Resource } from 'json-api';
import { AtomResource } from '../classes/atom-resource';
import { ResourceConfig } from '../../resources/resources-interfaces/resource-config';
import { AtomService } from '../atom.service';
import { NumberFilter, ResourcesFilter, StringFilter } from '../../filter/filter';

@Resource({
  type: 'enums',
})
export class Enum extends AtomResource {
  @Attribute() code?: string;
  @Attribute() label?: string;
  @Attribute() desc?: string;
  @Attribute() enum_table?: string;
  @Attribute() enum_field?: string;


}
export class EnumConfig implements ResourceConfig {
  tables = {
    columns: [
      {
        columnDef: 'id',
        displayedDatas: [{ path: ['id'], class: 'main' }],
        header: 'ID',
        translatable: false,
        displayed: true,
        sort: 'id',
      },
      {
        columnDef: 'enum_table',
        displayedDatas: [{ path: ['enum_table'], class: 'mat-body-2'}],
        header: 'Table Name',
        displayed: true,
        link: {
          detail: true,
        },
        sort: 'enum_table',
      },
      {
        columnDef: 'Table Field',
        displayedDatas: [{ path: ['enum_field'], class: 'mat-body-2'}],
        header: 'Table Field',
        displayed: true,
        link: {
          detail: true,
        },
        sort: 'enum_field',
      },
      {
        columnDef: 'code',
        displayedDatas: [{ path: ['code'], class: 'mat-body-2', },],
        header: 'Code',
        displayed: true,
        link: {
          detail: true,
        },
        sort: 'code',
      },
      {
        columnDef: 'label',
        displayedDatas: [{ path: ['label'], class: 'mat-body-2'}],
        header: 'Label',
        displayed: true,
        link: {
          detail: true,
        },
        sort: 'label',
      },
      {
        columnDef: 'Description',
        displayedDatas: [
          {
            path: ['desc'],
            class: 'mat-body-2',
          },
        ],
        header: 'Description',
        displayed: true,
        link: {
          detail: true,
        },
        sort: 'desc',
      },
      {
        columnDef: 'actions',
        header: 'Actions',
        displayed: true,
      },
    ]
  }
  detail = {
    header: {
      icon: 'playlist_add_icon',
      title: [
        {
          path: ['label'],
          translatable: false,
        },
      ],
      id: true,
    },
    elements: [
      {
        showEmpty: true,
        columns: true,
        list: [
          {
            icon: 'storage',
            title: 'Table Name',
            value: {
              path: ['enum_table'],
              translatable: false,
            }
          },
          {
            icon: 'view_column',
            title: 'Table Field',
            value: {
              path: ['enum_field'],
              translatable: false,
            }
          },
          {
            icon: 'badge',
            title: 'Code',
            value: {
              path: ['code'],
              translatable: false,
            }
          },
          {
            icon: 'label',
            title: 'Label',
            value: {
              path: ['label'],
              translatable: false,
            }
          },
          {
            icon: 'description',
            title: 'Description',
            value: {
              path: ['desc'],
              translatable: false,
            }
          },
        ]
      }
    ],
  };
  wizard = {
    noCloseAfterCreation: false,
    tabs: [
      {
        title: 'Enum',
        formGroup: 'enum',
        list: [
          {
            type: 'resourceList',
            title: 'Table Name',
            formControl: 'enum_table',
            APIKey: 'enum_table',
            required: true,
            translatable: false,
            custom: {
              onlyEnum: true,
              attributes :true
            },
            /*activatingSequence:[
              {
                group: 'enum',
                control: 'enum_field',
              }]*/
          },
          {
            type: 'text',
            title: 'Table Field',
            formControl: 'enum_field',
            APIKey: 'enum_field',
            required: true,
            custom: {
              parent: 'enum_table',
            },
          },
          {
            type: 'text',
            title: 'Code',
            formControl: 'code',
            APIKey: 'code',
            required: true,
            translatable: false,
          },
          {
            type: 'text',
            title: 'Label',
            formControl: 'label',
            APIKey: 'label',
            required: true,
            translatable: false,
          },
          {
            type: 'text',
            title: 'Description',
            formControl: 'desc',
            APIKey: 'desc',
            required: false,
          },
        ],
      }
    ],
  };
  resource = Enum;
  resourceName?: string | undefined = 'enums';
  resourceKey?: string | undefined = 'enums';
  resourceKeySingle?: string | undefined = 'enum';
  filters = [
    new NumberFilter('id', 'ID'),
    new ResourcesFilter(this.atom, true, 'enum_table','table', 'Table Name'),
    new ResourcesFilter(this.atom, true, 'enum_field','field', 'Table Field'),
    new StringFilter('code', 'Code',true),
    new StringFilter('label', 'Label'),
    new StringFilter('desc','Description'),
  ];
  constructor(private atom: AtomService) {}
}
